storefrontApp.controller('CheckoutController', ['$scope', 'checkoutService', function ($scope, checkoutService) {
    getCountries();

    function getCountries() {
        checkoutService.getCountries().then(function (response) {
            console.log(response);
        })
    }

}]);
